import React from "react";
import CategoryGlobalList from "./CategoryGlobalList";
import AddUpdateCategoryGlobalPage from "./AddUpdateCategoryGlobalPage";
import {
  ICategoryGlobalPageProps,
  ICustomerPageState,
} from "../../../interfaces/Index";
import HeadingText from "../../common/HeadingText/HeadingText";

export default class CategoryGlobalPage extends React.Component<
  ICategoryGlobalPageProps,
  ICustomerPageState
> {
  constructor(props: ICategoryGlobalPageProps) {
    super(props);
    this.state = {
      isEdit: false,
      showAddUpdatePage: false,
      selectedCategoryGlobal: null,
      isCategoryGlobalAddUpdate: false,
      searchText: "",
      currentListPosition: 0,
    };
  }

  renderAddUpdateCategoryGlobalPage = () => {
    const { isEdit, selectedCategoryGlobal } = this.state;
    const {
      isLoading,
      isError,
      error,
      createCategoryGlobal,
      isCategoryGlobalAdded,
      getCoreCategoriesGlobal,
      coreCategories,
      isCoreCategoriesGlobalFetched,
      history,
      location,
      match,
      isCategoryGlobalUpdated,
      updateCategoryGlobal,
      fetchCities,
      citiesList,
      isCityListFetched,
      fetchCategoriesGlobal,
      categoriesGlobal,
      isCategoryGlobalAddedorUpdated,
    } = this.props;
    return (
      <AddUpdateCategoryGlobalPage
        fetchCategoriesGlobal={fetchCategoriesGlobal}
        categoriesGlobal={categoriesGlobal}
        isCategoryGlobalAddedorUpdated={isCategoryGlobalAddedorUpdated}
        selectedCategoryGlobal={selectedCategoryGlobal}
        isEdit={isEdit}
        backButtonHandler={this.navigateBackToListingPage}
        isLoading={isLoading}
        isError={isError}
        error={error}
        updateCategoryGlobal={updateCategoryGlobal}
        createCategoryGlobal={createCategoryGlobal}
        isCategoryGlobalAdded={isCategoryGlobalAdded}
        isCategoryGlobalUpdated={isCategoryGlobalUpdated}
        getCoreCategoriesGlobal={getCoreCategoriesGlobal}
        coreCategories={coreCategories}
        isCoreCategoriesGlobalFetched={isCoreCategoriesGlobalFetched}
        history={history}
        location={location}
        match={match}
        fetchCities={fetchCities}
        citiesList={citiesList}
        isCityListFetched={isCityListFetched}
        dummyValidation={false}
      />
    );
  };

  renderCategoryGlobalListing = () => {
    const {
      categoriesGlobal,
      isFetchCategoryGlobalLoading,
      isFetchCategoryGlobalError,
      error,
      pagination,
      isCategoryGlobalUpdated,
      isCategoryGlobalAdded,
      fetchCategoriesGlobal,
    } = this.props;
    const { isCategoryGlobalAddUpdate, searchText, currentListPosition } =
      this.state;
    return (
      <>
        <section className="main-heading-margin">
          <HeadingText text="Categories" isMainHeading={true} />
        </section>
        <CategoryGlobalList
          fetchCategoriesGlobal={fetchCategoriesGlobal}
          categoriesGlobal={categoriesGlobal}
          pagination={pagination}
          isLoading={isFetchCategoryGlobalLoading}
          isError={isFetchCategoryGlobalError}
          error={error}
          isCategoryGlobalAddedorUpdated={isCategoryGlobalAddUpdate}
          isCategoryGlobalAdded={isCategoryGlobalAdded}
          isCategoryGlobalUpdated={isCategoryGlobalUpdated}
          addUpdatePageHandler={this.toggleAddUpdateCategoryGlobalPage}
          retainedSearchText={searchText}
          currentListPosition={currentListPosition}
        />
      </>
    );
  };

  toggleAddUpdateCategoryGlobalPage = (
    isEdit: boolean = false,
    selectedCategoryGlobal: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedCategoryGlobal: selectedCategoryGlobal,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isCategoryGlobalAddUpdate: isAddUpdate,
      searchText: searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
    });
  };

  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderAddUpdateCategoryGlobalPage()
          : this.renderCategoryGlobalListing()}
      </div>
    );
  }
}
